/**
 * Accordion Component
 *
 * Sets attribute "aria-expanded" to true/false, which is used
 * in _component-accordion.scss to determine which accordion to display
 */


var aucor_accordion_init = function(accordion, i) {
  var tab = accordion;
  var panel = accordion.parentNode.querySelector('.js-accordion-panel');

  tab.setAttribute('aria-expanded', 'false');
  tab.setAttribute('aria-selected', 'false');
  tab.setAttribute('type', 'button');
  tab.setAttribute('aria-controls', 'accordion-' + i);

  panel.setAttribute('id', 'accordion-' + i);
  panel.setAttribute('aria-hidden', 'true');
  panel.setAttribute('aria-labelledby', 'accordion-' + i);
};

var aucor_accordion_focus = function(e) {
  var tab = e.currentTarget;

  if (tab.getAttribute('aria-selected') === 'true') {
    tab.setAttribute('aria-selected', 'false');
  } else {
    tab.setAttribute('aria-selected', 'true');
  }
};

var aucor_accordion_toggle = function(e) {
  e.stopPropagation();

  var tab = e.currentTarget;
  var panel = e.currentTarget.parentNode.querySelector('.js-accordion-panel');

  if (tab.getAttribute('aria-expanded') === 'true') {
    tab.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
  } else {
    tab.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
  }
};

var aucor_accordion_find_and_init = function() {
  var accordion = document.querySelectorAll('.js-accordion-header');
  for (var i = 0; i < accordion.length; i++) {
    aucor_accordion_init(accordion[i], i);

    accordion[i].addEventListener('click', aucor_accordion_toggle, false);
    accordion[i].addEventListener('focus', aucor_accordion_focus, false);
    accordion[i].addEventListener('blur', aucor_accordion_focus, false);
  }
}
aucor_accordion_find_and_init();
